import React from 'react';

import { useClassnames } from '@lumapps/classnames';
import { FlexBox } from '@lumapps/lumx/react';

import './index.scss';

const CLASSNAME = 'lumx-chat-typing-animation';

interface ChatTypingAnimationProps {
    className?: string;
}

/**
 * Simple chat animation to display while someone is typing
 * @family Chat
 * @param ChatTypingAnimationProps
 * @returns ChatTypingAnimation
 */
export const ChatTypingAnimation: React.FC<ChatTypingAnimationProps> = ({ className }) => {
    const { block, element } = useClassnames(CLASSNAME);

    return (
        <div className={block([className])} aria-hidden="true">
            <FlexBox orientation="horizontal" gap="tiny">
                <div className={element('dot', { 1: true })} />
                <div className={element('dot', { 2: true })} />
                <div className={element('dot', { 3: true })} />
            </FlexBox>
        </div>
    );
};
